import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {t} from 'react-switch-lang';

const SelectList = ({
                      name,
                      options,
                      className,
                      isDisabled,
                      selectedItem,
                      placeholder,
                      defaultValue = null,
                      ...rest
                    }) => {
  if (!useFormContext())
    throw new Error('Smart component must be in "Form" wrapper component!');
  if (!name) {
    throw new Error('"name" field is required for SelectList component');
  }
  if (!options) {
    throw new Error(
      '"options" field is required for SelectList component'
    );
  }

  const {control, errors} = useFormContext();

  return (
    <>
      <Controller
        control={control}
        name={name}
        as={Select}
        options={options}
        className={`${className} ${errors[name] && ' error-field'}`}
        components={{IndicatorSeparator: () => null}}
        isClearable={true}
        isDisabled={isDisabled}
        isSearchable={true}
        placeholder={placeholder}
        defaultValue={defaultValue}
        noOptionsMessage={() => t('common.noOption') }
        {...rest}
      />
      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default SelectList;

SelectList.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.array
};